module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-tit"
  }, [_c('b', [_vm._v("APPLIQUÉ BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_c('i', [_vm._v("by Renée Plains")])]), _vm._v(" "), _c('p', {
    staticClass: "intro-txt"
  }, [_c('i', [_vm._v("I love handwork because I find it so relaxing, and hand appliqué is one of my favorites. If you are new to this technique, here are some guidelines to help you get started as well as some other appliqué techniques used in this book’s projects")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Needle-Turn Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("1.")]), _vm._v(" Draw your design on the dull side of a piece of freezer paper (such as Quilter’s Freezer Paper Sheets by C&T Publishing). Many quilt shops carry freezer paper. It’s not just for grocery stores anymore!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("2.")]), _vm._v(" Cut out the drawn design on freezer paper directly on the line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("3.")]), _vm._v(" Iron the shiny side of the freezer paper to the right side of the fabric being appliquéd. Be sure to leave at least a ¼˝ fabric beyond the edge of the design for a seam allowance to turn under.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("4.")]), _vm._v(" With a pencil, trace the design onto the fabric. For dark fabrics, use a white chalk pencil. To prevent the fabric from slipping, place the fabric on top of a piece of sandpaper. You can easily make your own sandpaper board by gluing a piece of sandpaper on to a piece of Masonite.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("5.")]), _vm._v(" Cut out the appliqué pieces, adding a "), _c('span', {
    staticClass: "fon"
  }, [_vm._v("⅛")]), _vm._v("˝ seam allowance. If the piece has curves, clip the inside corners. Fig. A")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fig. A")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("6.")]), _vm._v(" Place and pin the appliqué pieces on the background fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("7.")]), _vm._v(" Fold the seam allowance toward the back of the appliqué piece, tucking it under and creasing the design on the drawn line. Using a very small stitch, sew the appliqué piece to the background fabric. Start stitching from the wrong side of the fabric, coming up through the very edge in the fold of the appliqué. Then go back down through the background fabric right under the fold to create invisible appliqué stitches. Fig. B")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fig. B")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Reverse Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This method works great for windows and other openings that are perceived to appear behind another appliquéd object.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("1.")]), _vm._v(" Draw the necessary shape on the appliqué piece that lays on top of the background fabric and carefully cut a slit in the center of it. We used a rectangle for our example. Fig. C")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fig. C")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("2.")]), _vm._v(" Leaving a "), _c('span', {
    staticClass: "fon"
  }, [_vm._v("⅛")]), _vm._v("˝ seam allowance, cut out the center portion of the rectangle to reveal the background fabric behind it. Fig. D")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fig. D")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("3.")]), _vm._v(" Clip the seam allowance, particularly around curves and corners. Then tuck the seam allowance under and you’re ready to stitch! Fig. E")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fig. E")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wool Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Appliquéing with wool is easy because you don’t need to turn under the edges as you stitch. Here is a quick and easy appliqué method when working with this fun material.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("1.")]), _vm._v(" Draw your design on freezer paper to make a template.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("2.")]), _vm._v(" Cut out the templates directly on the drawn line, then iron them to the wool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("3.")]), _vm._v(" Cut out the wool appliqué pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("4.")]), _vm._v(" Pin or baste the wool appliqué pieces to the background fabric. It is also easy to hold them in place with tiny bits of Roxanne Glue-Baste-It.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("5.")]), _vm._v(" Stitch the appliqué pieces in place. I use a primitive stitch, which resembles a buttonhole stitch—only it is much faster.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Embroidery Stitch Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The projects in this book use a variety of hand stitches to achieve a folk art feel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Here are the ones that you will need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('b', [_vm._v("Method A")]), _vm._v(" completes each X as you go. "), _c('b', [_vm._v("Method B")]), _vm._v(" works a full row of half-stitches ( "), _c('b', [_vm._v("/")]), _vm._v(" ), then stitches back over the first half-stitches with a ( "), _c('b', [_vm._v("\\")]), _vm._v(" ) to complete the X’s. "), _c('i', [_vm._v("Note:")]), _vm._v(" It is important to cross all the top threads in the same direction (either all "), _c('b', [_vm._v("\\")]), _vm._v(" or all "), _c('b', [_vm._v("/")]), _vm._v("). It doesn’t matter which of those directions you opt for, but be consistent once you pick one or your stitches will have an uneven color.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97b19048","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm-chapter.vue
// module id = 66
// module chunks = 0